export default "__VITE_ASSET__C5JcdOTO__"